import React from "react";

import PropTypes from "prop-types";

import RbControl from "../RbControl";
import RbNumberInput from "../RbNumberInput";

const RbNumberControl = React.forwardRef(function RbNumberControl(props, ref) {
  const {
    autoComplete,
    autoFocus,
    decimalScale,
    defaultValue,
    disableUnderline,
    endAdornment,
    inputComponent,
    inputProps,
    InputProps,
    inputRef,
    locale,
    margin,
    multiline,
    name,
    onChange,
    onChangeValue,
    placeholder,
    readOnly,
    rounded,
    rows,
    rowsMax,
    startAdornment,
    type,
    value,
    ...other
  } = props;

  return (
    <RbControl
      ref={ref}
      renderComponent={(params) => (
        <RbNumberInput
          {...params}
          {...InputProps}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          decimalScale={decimalScale}
          defaultValue={defaultValue}
          disableUnderline={disableUnderline}
          endAdornment={endAdornment}
          inputComponent={inputComponent}
          inputProps={inputProps}
          inputRef={inputRef}
          locale={locale}
          margin={margin}
          multiline={multiline}
          name={name}
          onChange={onChange}
          onChangeValue={onChangeValue}
          placeholder={placeholder}
          readOnly={readOnly}
          rounded={rounded}
          rows={rows}
          rowsMax={rowsMax}
          startAdornment={startAdornment}
          type={type}
          value={value}
        />
      )}
      {...other}
    />
  );
});

RbNumberControl.propTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  decimalScale: PropTypes.number,
  defaultValue: PropTypes.any,
  disableUnderline: PropTypes.bool,
  endAdornment: PropTypes.node,
  inputComponent: PropTypes.any,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  inputRef: PropTypes.any,
  locale: PropTypes.string,
  margin: PropTypes.oneOf(["dense", "none"]),
  multiline: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  rounded: PropTypes.bool,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  startAdornment: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.any,
};

RbNumberControl.defaultProps = {
  autoComplete: undefined,
  autoFocus: undefined,
  decimalScale: undefined,
  defaultValue: undefined,
  disableUnderline: undefined,
  endAdornment: undefined,
  inputComponent: undefined,
  inputProps: undefined,
  InputProps: undefined,
  inputRef: undefined,
  locale: undefined,
  margin: undefined,
  multiline: undefined,
  name: undefined,
  onChange: undefined,
  onChangeValue: undefined,
  placeholder: undefined,
  readOnly: undefined,
  rounded: undefined,
  rows: undefined,
  rowsMax: undefined,
  startAdornment: undefined,
  type: undefined,
  value: undefined,
};

export default React.memo(RbNumberControl);
